import { Url } from '@wix/da-url';
import { TipTapBaseNode } from '../../../components/Viewer/renderer';
import { EXTENSION_TYPE_NAME } from '../constants';

interface Props {
  node: TipTapBaseNode;
}

const Viewer = ({ node }: Props) => {
  const { user } = node.attrs ?? {};

  return (
    <a
      href={Url.userLink(user.username)}
      data-da-type={EXTENSION_TYPE_NAME}
      data-user={JSON.stringify(user)}
    >
      @{user.username}
    </a>
  );
};

Viewer.displayName = 'MentionViewer';

export default Viewer;
